import React, { Component } from 'react'
import { Modal, Form, Input, Radio, Row, Col } from 'antd'
import { gradients } from '../../../constants'

class channelCreateModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: false,
      errorMessage: '',
      coverType: 'image',
      coverAvatar: null,
      coverGradient: 0,
      avatar: null,
      name: null
    }
  }

  onCoverTypeChange = (e) => {
    this.setState({
      coverType: e.target.value,
      coverAvatar: null,
      avatar: null
    })
  }

  onAvatarSelect = (e) => {
    if (e.target.files[0]) {
      if (e.target.files[0].size > 3145728) {
        setTimeout(() => {
          this.props.form.setFields({
            avatar: {
              value: null,
              errors: [new Error('File size more than 3Mb')]
            }
          })
        }, 100)
        this.setState({
          coverAvatar: null,
          avatar: null
        })
      } else if ((e.target.files[0].type !== 'image/png') && (e.target.files[0].type !== 'image/jpeg') && (e.target.files[0].type !== 'image/bmp')) {
        setTimeout(() => {
          this.props.form.setFields({
            avatar: {
              value: null,
              errors: [new Error('Wrong file type')]
            }
          })
        }, 100)
        this.setState({
          coverAvatar: null,
          avatar: null
        })
      } else {
        this.setState({
          coverAvatar: window.URL.createObjectURL(e.target.files[0]),
          avatar: e.target.files[0]
        })
      }
    } else {
      this.setState({
        coverAvatar: null,
        avatar: null
      })
    }
  }

  setError = (payload) => {
    this.setState({
      error: payload
    })
  }

  handleOk = (e) => {
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.firstColor = gradients[this.state.coverGradient].firstColor
        values.secondColor = gradients[this.state.coverGradient].secondColor

        if (this.state.avatar) {
          values.avatar = this.state.avatar
        }

        this.setError(false)
        this.props.createChannel(values).then(response => {
          if (response && response.data.error) {
            this.setError(true)
            this.setState({
              errorMessage: response.data.error.message
            })
          } else {
            this.props.getChannelById(response.data.result.id)
            this.handleCancel()
          }
        })
      }
    })
  }

  handleCancel = (e) => {
    this.props.closeModal()
    this.setState({
      error: false,
      errorMessage: '',
      coverType: 'image',
      coverAvatar: null,
      coverGradient: 0,
      name: null,
      avatar: null
    })
  }

  render () {
    const { getFieldDecorator } = this.props.form

    const layout = {
      labelCol: {
        md: { span: 12 }
      },
      wrapperCol: {
        md: { span: 12 }
      }
    }

    let cardStyle = {
      backgroundImage: null
    }

    if (this.state.coverType === 'image') {
      cardStyle.backgroundImage = 'url(' + this.state.coverAvatar + ')'
    } else if (this.state.coverType === 'gradient') {
      cardStyle.backgroundImage = 'linear-gradient(90deg, ' + gradients[this.state.coverGradient].firstColor + ' 0%, ' + gradients[this.state.coverGradient].secondColor + ' 100%)'
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Create Channel'
        visible={this.props.status}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText={'Create'}
        okType='indigo'
        destroyOnClose
      >
        <Form onSubmit={this.handleOk} className='form'>
          { this.state.error ? <div className='form__error'>{ this.state.errorMessage }</div> : '' }

          <Row>
            <Col span={12}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Channel Name'>Channel Name</label>
              </div>
            </Col>
            <Col span={12}>
              <Form.Item>
                {getFieldDecorator('name', {
                  rules: [{
                    required: true,
                    message: 'Please input channel name',
                    max: 24,
                    pattern: /^[^ ][ a-zA-Z_\\-\\.0-9]*/
                  }]
                })(
                  <Input name='name' maxLength={24} onKeyUp={(e) => this.setState({ name: e.target.value })} />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Form.Item {...layout} label='Background Type'>
            <Radio.Group defaultValue={this.state.coverType} onChange={this.onCoverTypeChange}>
              <Radio.Button value='image'>Image</Radio.Button>
              <Radio.Button value='gradient'>Gradient</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <div style={{ height: '140px' }}>

            { this.state.coverType === 'image'
              ? <Row>
                <Col span={12}>
                  <div className='ant-form-item-label'>
                    <label className='ant-form-item' title='Background Image'>Upload an image</label>
                  </div>
                </Col>
                <Col span={12}>
                  <Form.Item>
                    {getFieldDecorator('avatar', {
                      rules: [{
                        required: true,
                        message: 'Please choose channel avatar'
                      }]
                    })(
                      <Input type='file' accept='image/*' name='avatar' onChange={this.onAvatarSelect} />
                    )}
                  </Form.Item>
                </Col>
              </Row> : null }

            { this.state.coverType === 'gradient'
              ? <Row>
                <Col span={12}>
                  <div className='ant-form-item-label'>
                    <label class='ant-form-item' title='Select a gradient'>Select a gradient</label>
                  </div>
                </Col>
                <Col span={12}>
                  <div className='channel-gradients'>
                    { gradients.map((item, index) =>
                      <div
                        className={this.state.coverGradient === index ? 'channel-gradients__item channel-gradients__item_active' : 'channel-gradients__item'}
                        onClick={() => this.setState({ coverGradient: index })}
                        key={index}
                        style={{ backgroundImage: 'linear-gradient(90deg, ' + gradients[index].firstColor + ' 0%, ' + gradients[index].secondColor + ' 100%)' }} />) }

                  </div>
                </Col>
              </Row> : null }

          </div>

          <div className='channel-preview'>
            <Row>
              <Col span={12}>
                <div className='channel-preview__label'>Preview</div>
                <p className='channel-preview__description'>This will look like this channel in the application</p>
              </Col>
              <Col span={12}>

                <div className='channel-preview__card' style={cardStyle}>
                  <div className='channel-preview__name'>{ this.state.name ? this.state.name : 'Channel Name' }</div>
                </div>
              </Col>
            </Row>
          </div>

        </Form>
      </Modal>
    )
  }
}

export default Form.create()(channelCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelCreateModal/ChannelCreateModal.jsx